import React, { useState, useEffect } from "react";
import "../../Styles/Pages/Admin/Farmers.css";
import Admin_topbar from "../../Layouts/Admin_layout/Admin_topbar";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Button,
  Pagination,
  Grid,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Autocomplete,
  Modal,
  Box,
} from "@mui/material";
import "../../Styles/Pages/admin_fieldofficers.css";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import CloseIcon from "@mui/icons-material/Close";
import { instance } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { FiEye, FiTrash2 } from "react-icons/fi";
import { formatDate } from "../../utils/helper";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  border: "1px solid #79c245",
  marginRight: "10px",
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#79c245",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontFamily: "Poppins,sans-serif",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

function Fields() {
  const navigate = useNavigate();
  const { farmer_hash } = useParams();
  const [fields, setFields] = useState([]);
  const [farmerName, setFarmerName] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredFields, setFilteredFields] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [fieldpage] = useState(10);

  // Delete modal state
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteFieldData, setDeleteFieldData] = useState(null);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    borderRadius: "2px",
  };

  const indexOfLastfield = currentPage * fieldpage;
  const indexOfFirstfield = indexOfLastfield - fieldpage;
  const currentfield = filteredFields.slice(
    indexOfFirstfield,
    indexOfLastfield
  );

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase().trim();
    setSearch(query);

    if (!query) {
      setFilteredFields(fields);
    } else {
      const filtered = fields.filter((field) =>
        Object.values(field).some(
          (value) =>
            value !== null &&
            value !== undefined &&
            value.toString().toLowerCase().includes(query)
        )
      );
      setFilteredFields(filtered);
    }

    setCurrentPage(1);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchFarmerName = async () => {
    try {
      const response = await instance.get("/getFarmers");
      setFarmerName(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchFields = async () => {
    try {
      const hash = farmer_hash ? `?farmer_hash=${farmer_hash}` : "";
      const response = await instance.get(`/field/getFields${hash}`);
      setFields(response.data.data);
      setFilteredFields(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFields();
    fetchFarmerName();
  }, []);

  const handleDeleteClick = (field) => {
    setDeleteFieldData(field);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteFieldData) return;
    try {
      const response = await instance.delete(`/field/deleteField?field_id=${deleteFieldData._id}`);
      if (response.data.success) {
        toast.success("Field deleted successfully");
        fetchFields();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error deleting field");
    } finally {
      setDeleteModalOpen(false);
      setDeleteFieldData(null);
    }
  };


  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <Admin_topbar />
      <div className="officer_section">
        <section className="main_box">
          <div className="container-fluid">
            <div className="table_box">
              <TableContainer component={Paper}>
                <div className="table_inbox">
                  <div className="add_user_list">
                    <div className="add_user_content">
                      <div
                        style={{
                          fontFamily: "Poppins,sans-serif",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        {farmer_hash ? `Fields of ${farmerName.find(farmer => farmer.hash === farmer_hash)?.name || ""}` : "Fields"}
                      </div>
                    </div>
                    <div className="add_user">
                      <div>
                        <Search>
                          <SearchIconWrapper>
                            <SearchIcon />
                          </SearchIconWrapper>
                          <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                            type="search"
                            value={search}
                            onChange={handleSearch}
                          />
                        </Search>
                      </div>
                    </div>
                    {farmer_hash ? <div>
                      <button
                        onClick={() => navigate("/admin/Farmers")}
                        className="back-to-farmers"
                      >
                        Back
                      </button>
                    </div>
                      : null}
                  </div>
                  <Table
                    className="adduser_table user_table product_table"
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow className="table_head">
                        <TableCell align="center" className="first-child">
                          Sl.No
                        </TableCell>
                        <TableCell align="center" className="second-child">
                          Village Name
                        </TableCell>
                        <TableCell align="center" className="second-child">
                          Mandal Name
                        </TableCell>
                        <TableCell align="center" className="second-child">
                          Type Of Customer
                        </TableCell>
                        <TableCell align="center" className="third-child">
                          Plantation Date
                        </TableCell>
                        <TableCell align="center" className="third-child">
                          Area (Ha)
                        </TableCell>
                        <TableCell align="center">Initial Visit</TableCell>
                        {/* <TableCell align="center">Last Visit</TableCell> */}
                        <TableCell align="center">Plantation Status</TableCell>
                        <TableCell align="center">View Field Details</TableCell>
                        <TableCell align="center">Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="table_body">
                      {currentfield.length > 0 ? (
                        currentfield.map((field, index) => (
                          <TableRow key={field._id}>
                            <TableCell align="center">
                              {index + 1 + (currentPage - 1) * fieldpage}
                            </TableCell>
                            <TableCell align="center">
                              {field?.village_name || "--"}
                            </TableCell>
                            <TableCell align="center">
                              {field?.mandal_name || "--"}
                            </TableCell>
                            <TableCell align="center">
                              {field?.type_of_customer || "--"}
                            </TableCell>
                            <TableCell align="center">
                              {formatDate(field?.plantation_date) || "--"}
                            </TableCell>
                            <TableCell align="center">
                              {field?.area_in_acres || "--"}
                            </TableCell>
                            <TableCell align="center">
                              {formatDate(field?.createdAt) || "--"}
                            </TableCell>
                            {/* <TableCell align="center">
                              {formatDate(field?.updatedAt)}
                            </TableCell> */}
                            <TableCell align="center">
                              {field?.plantation_status || "--"}
                            </TableCell>
                            <TableCell align="center">
                              <NavLink
                                to={`/admin/Fields/FieldDetails/${field.hash}`}
                                className="farmer-details"
                              >
                                <FiEye />
                              </NavLink>
                            </TableCell>
                            <TableCell align="center">
                              <span onClick={() => handleDeleteClick(field)} style={{ color: '#f44336', cursor: 'pointer' }}>
                                <FiTrash2 />
                              </span>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableCell colSpan={12} align="center">
                          <Typography>No matched items</Typography>
                        </TableCell>
                      )}
                    </TableBody>
                  </Table>
                  <div className="pagination_table">
                    <Pagination
                      count={Math.ceil(filteredFields.length / fieldpage)}
                      page={currentPage}
                      onChange={(event, page) => paginate(page)}
                      shape="rounded"
                      variant="outlined"
                    />
                  </div>
                </div>
              </TableContainer>
            </div>
          </div>
        </section>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <Box sx={modalStyle}>
          <div id="delete-modal-title" style={{ fontWeight: 'bold', fontSize: '16px', color: '#f44336' }}>
            ⚠️ Caution - Delete Field
          </div>
          <div style={{ margin: '12px 0', fontFamily: 'Poppins,sans-serif', fontSize: '14px' }}>
            Are you sure you want to delete the field <b>{deleteFieldData?.village_name || 'this field'}</b>? This action cannot be undone.
          </div>
          <div id="delete-modal-description">
            <Button variant="contained" className="yes" onClick={handleConfirmDelete}>
              Yes, Delete
            </Button>
            <Button variant="contained" className="no" onClick={() => setDeleteModalOpen(false)}>
              No, Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default Fields;
